import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { Layout, LayoutBody, LayoutFooter, LayoutHeader, HeaderDisplay } from 'common-controls/Drawer/index'
import { ah, sh, compose, ReduxWrapper, QueryWrapper } from 'common-data/datahelpers'
import { FormBox, ComboBox, Row, FieldLayoutSizes, FormBoxHeader, TextAreaBox } from 'common-controls/Core/index'
import { BuildMessageBusEvents } from 'common-tools/index'

export const FeedbackAddEvents = BuildMessageBusEvents('Feedback.FeedbackAdd')
const formName = 'FeedbackAdd'
const title = 'Feedback Add'
const subTitle = 'Add Feedback'
const successMessage = 'Feedback Added'
const cleanOnUnmount = true

function FeedbackAddPlain (props) {
  const { close, formSubmit, AddFeedback, showSuccess, formStopSubmit, showWarning, GetLookups, data: { Lookups = {} } } = props
  const [initialValues, setInitialValues] = useState({})
  const [featureOptions, setFeatureOptions] = useState([])
  const SectionOptions = _.concat([{ Text: 'Select a section', Value: '' }], Lookups.GeneralLookups || [])

  useEffect(() => {
    setInitialValues({
    })
    GetLookups({
      Names: [`GeneralLookups?Area=Admin&LookupTypeName=Feedbacks`]
    })
  }, [])

  function onSubmit (values) {
    const errors = {}
    if (!values.Section) {
      errors.Section = 'App Section cannot be blank'
    }
    if (!values.Feature) {
      errors.Feature = 'App Feature cannot be blank'
    }
    if (!values.Description) {
      errors.Description = 'Description cannot be blank'
    }
    if (_.isEmpty(errors) === false) {
      showWarning(errors)
      formStopSubmit(formName, errors)
      return false
    } else {
      AddFeedback(values).then(() => {
        showSuccess(successMessage)
        close([FeedbackAddEvents.NewSuccess(), FeedbackAddEvents.NewClosed()])
      })
    }
  }

  function onSetSection (val) {
    const featureArray = [{ Text: 'select a feature', Value: '' }]
    if (val.ExtraData.LookupChildren) {
      for (let a of val.ExtraData.LookupChildren) {
        const newObj = {
          Text: a.Name,
          Value: a.Name
        }
        const cloneNewObj = _.clone(newObj)
        featureArray.push(cloneNewObj)
      }
    }
    setFeatureOptions(featureArray)
  }
  return (
    <Layout onClick={() => { close([{ Type: FeedbackAddEvents.Close }]) }}>
      <LayoutHeader>
        <HeaderDisplay
          title={title}
          subTitle={subTitle}
        />
      </LayoutHeader>
      <LayoutBody>
        <FormBox form={formName} simpleBody initialValues={initialValues} onSubmit={onSubmit}>
          <FormBoxHeader title='Details' />
          <Row>
            <ComboBox layout={FieldLayoutSizes.Six} name='Section' label='App Section' options={SectionOptions}
              extraDataMap={(val) => { onSetSection(val) }} />
            <ComboBox layout={FieldLayoutSizes.Six} name='Feature' label='App Feature' options={featureOptions} />
          </Row>
          <Row>
            <TextAreaBox layout={FieldLayoutSizes.Full} name='Description' label='Description' rows={5} />
          </Row>
        </FormBox>
      </LayoutBody>
      <LayoutFooter
        actions={[
          { size: 'lg', color: 'purple', onClick: () => { formSubmit(formName) }, text: 'Save' },
          { size: 'lg', color: 'purple', outline: true, onClick: () => { close([{ Type: FeedbackAddEvents.Close }]) }, text: 'Cancel' }
        ]}
      />
    </Layout>
  )
}

export const FeedbackAdd = compose(
  ReduxWrapper([
    sh.SessionAccount
  ], [
    ah.formCheckForSubmissionErrors,
    ah.formSubmit,
    ah.showSuccess,
    ah.formSetFieldValue,
    ah.formStopSubmit,
    ah.showWarning
  ]),
  QueryWrapper({
    key: formName,
    cleanOnUnmount: cleanOnUnmount,
    actions: [
      {
        url: '/Services/Profile/Feedbacks/AddFeedback',
        prop: 'AddFeedback',
        map: false
      },
      {
        url: '/Services/Data/Lookups/Get',
        prop: 'GetLookups',
        map: 'Lookups'
      }
    ]
  })
)(FeedbackAddPlain)

export default FeedbackAdd
